<template>
  <div class="trainers">
    <weui-search-bar placeholder="搜索会员" v-model.trim="query" />
    <sidebar :keys="keys" @click-key="scrollTo" />
    <div class="content">
      <weui-group :notitle="idx === 0" v-for="(app, idx) in trainerApplies" :key="app.id" >
        <trainer-apply-cell :trainer-apply="app" />
      </weui-group>
      <trainer-group v-for="(trainers, key) in groupedTrainers" :key="key" :title="key" :ref="`key_${key}`">
        <trainer-cell v-for="t in trainers" :trainer="t" :key="t.id" @click="selectTrainer(t)" />
      </trainer-group>
    </div>
    <router-link role="button" class="create" :to="{ name: ROUTE_TRAINER_CREATE }">
      <div class="symbol">+</div>
      <div class="create-text">新增会员</div>
    </router-link>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash.debounce';
import { WeuiSearchBar, WeuiGroup, WeuiCell } from '@/components/weui';

import Sidebar from '@/components/trainer/Sidebar';
import TrainerGroup from '@/components/trainer/TrainerGroup';
import TrainerApplyCell from '@/components/trainer/TrainerApplyCell';
import TrainerCell from '@/components/trainer/TrainerCell';

import { FETCH_GROUPED_TRAINERS } from '@/store/trainer/types';
import { FETCH_TRAINER_APPLIES } from '@/store/trainer_apply/types';
import { ROUTE_TRAINER_VIEW, ROUTE_TRAINER_CREATE } from '@/router/names';

const { mapState, mapActions } = createNamespacedHelpers('trainer');
const { mapState: mapTrainerApplyState, mapActions: mapTrainerApplyActions } = createNamespacedHelpers('trainer_apply');

export default {
    name: 'Trainers',
    data() {
        return {
            ROUTE_TRAINER_CREATE,
            query: null,
        };
    },
    computed: {
        ...mapState({
            groupedTrainers: state => state.grouped || {},
        }),
        ...mapTrainerApplyState({
            trainerApplies: state => state.trainer_applies || [],
        }),
        keys() {
            return Object.keys(this.groupedTrainers);
        },
    },
    watch: {
        // eslint-disable-next-line func-names
        query: debounce(function (newVal) {
            this.fetchGroupedTrainers({
                query: newVal,
            });
        }, 200),
    },
    created() {
        this.fetchGroupedTrainers();
        this.fetchTrainerApplies();
    },
    methods: {
        ...mapActions({
            fetchGroupedTrainers: FETCH_GROUPED_TRAINERS,
        }),
        ...mapTrainerApplyActions({
            fetchTrainerApplies: FETCH_TRAINER_APPLIES,
        }),
        scrollTo(payload) {
            const ele = this.$refs[`key_${payload.key}`];
            if (Array.isArray(ele)) {
                window.scrollTo(0, ele[0].$el.offsetTop);
            }
        },
        selectTrainer(trainer) {
            this.$router.push({
                name: ROUTE_TRAINER_VIEW,
                params: {
                    id: trainer.id,
                },
            });
        },
    },
    components: {
        WeuiSearchBar,
        Sidebar,
        WeuiGroup,
        WeuiCell,
        TrainerGroup,
        TrainerCell,
        TrainerApplyCell,
    },
};
</script>

<style lang="scss" scoped>
.trainers {
    padding-bottom: 18.666666666vw;
}

.trainer-group {
    margin-top: 5.333333333vw;
}

.create {
    position: fixed;
    bottom: 0;
    width: 100vw;
    height: 13.333333333vw;
    display: flex;
    align-items: center;
    text-align: center;
    z-index: 100;

    .symbol {
        width: 20vw;
        flex: none;
        background-color: white;
        color: #ff7245;
        font-size: 8.533333333vw;
        line-height: 1.5625;
    }

    .create-text {
        flex: auto;
        background-color: #ff7245;
        color: white;
        font-size: 6.4vw;
        line-height: 13.333333333vw;
    }
}
</style>



// WEBPACK FOOTER //
// src/containers/trainer/Index.vue